// extracted by mini-css-extract-plugin
module.exports = {"svgIcon":"_3R-6peHjC-zs-52olgWN7N","templatesTableWrapper":"_2GRdZRzEfklTxC1T6V85M0","withSharedTo":"_8kbqbzqsBaaoOjujW0uVf"};